module.exports = "/images/vendor/jquery-ui/themes/base/ui-icons_444444_256x240.png?f83a8b8886694eaef4505dd80af7a430";